export var googleGeoCoderActionTypes;
(function (googleGeoCoderActionTypes) {
    googleGeoCoderActionTypes["INITIAL_GOOGLE_GEO_CODER_STATE"] = "INITIAL_GOOGLE_GEO_CODER_STATE";
    googleGeoCoderActionTypes["RECEIVE_GOOGLE_GEO_CODER_STATE"] = "RECEIVE_GOOGLE_GEO_CODER_STATE";
    googleGeoCoderActionTypes["GOOGLE_GEO_CODER_LOADING_STATE"] = "GOOGLE_GEO_CODER_LOADING_STATE";
    googleGeoCoderActionTypes["ABORTED_GOOGLE_GEO_CODER_STATE"] = "ABORTED_GOOGLE_GEO_CODER_STATE";
    googleGeoCoderActionTypes["RECEIVE_GEOCODER_FAILED"] = "RECEIVE_GEOCODER_FAILED";
})(googleGeoCoderActionTypes || (googleGeoCoderActionTypes = {}));
export var initialGoogleGeoCoderState = {
    type: googleGeoCoderActionTypes.INITIAL_GOOGLE_GEO_CODER_STATE
};
